import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);


function scanLinkSerial(params) {
	return client.post("tunnel/api/public/scan/scan-serial", qs.stringify({
		link: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	scanLinkSerial,
};